"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PLPFeature = void 0;
let PLPFeature = exports.PLPFeature = /*#__PURE__*/ function(PLPFeature) {
    /** Enable personal subscriptions, docs: https://dev.azure.com/oriflame/GlobalDev/_wiki/wikis/GlobalDev.wiki/11422/Personal-subscriptions */ PLPFeature["PersonalSubscriptions"] = "7D673EF4-D085-44B5-BB1C-8FE57F1286BD";
    /** When enabled then hero banner,promo banners and front page banners are displayed in the split format which is in compliance with EAA. */ PLPFeature["DisplaySplitBanners"] = "A4289BD0-E380-42E6-9011-04EE89C98243";
    return PLPFeature;
}({});
